// Tomate do Pomodoro: saltita com o modo ligado; `still` = parado e apagado (desligado);
// `relaxed` = hora de relaxar — olhos fechados, pulinho lento e "z" subindo (AC-189).
import { cls } from './NewTaskForm';

export function Tomato({ size = 96, still = false, relaxed = false }: { size?: number; still?: boolean; relaxed?: boolean }) {
  return (
    <svg
      className={cls('tomato', still && 'tomato--still', relaxed && 'tomato--relax')}
      width={size}
      height={size}
      viewBox="0 0 96 96"
      aria-hidden="true"
      focusable="false"
    >
      <ellipse className="tomato__shadow" cx="48" cy="88" rx="24" ry="4" />
      <g className="tomato__body">
        <path d="M48 26c20 0 34 12 34 30S68 86 48 86 14 74 14 56s14-30 34-30Z" fill="#EF4444" />
        <path d="M30 40c4-6 10-9 16-9" stroke="#FCA5A5" strokeWidth="5" strokeLinecap="round" fill="none" />
        <g className="tomato__leaf">
          <path d="M48 28c-3-6-10-8-16-6 4 3 9 5 16 6Zm0 0c3-6 10-8 16-6-4 3-9 5-16 6Zm0 0c-6 1-11 5-12 10 5-1 9-4 12-10Zm0 0c6 1 11 5 12 10-5-1-9-4-12-10Z" fill="#22C55E" />
          <path d="M48 28V16" stroke="#16A34A" strokeWidth="4" strokeLinecap="round" />
        </g>
        {relaxed ? (
          <>
            <path d="M34 56c2 2.6 7 2.6 9 0M53 56c2 2.6 7 2.6 9 0" stroke="#1A1405" strokeWidth="2.6" strokeLinecap="round" fill="none" />
            <path d="M43 66c3 2 7 2 10 0" stroke="#1A1405" strokeWidth="2.6" strokeLinecap="round" fill="none" />
          </>
        ) : (
          <>
            <circle cx="39" cy="56" r="3.2" fill="#1A1405" />
            <circle cx="57" cy="56" r="3.2" fill="#1A1405" />
            <path d="M42 65c3 3 9 3 12 0" stroke="#1A1405" strokeWidth="2.6" strokeLinecap="round" fill="none" />
          </>
        )}
      </g>
      {relaxed && (
        <g className="tomato__zzz" fill="#93C5FD" fontWeight="700" fontFamily="inherit">
          <text x="70" y="30" fontSize="12">z</text>
          <text x="78" y="20" fontSize="9">z</text>
          <text x="84" y="12" fontSize="7">z</text>
        </g>
      )}
    </svg>
  );
}
